module.exports = __webpack_public_path__ + "assets/img/goods-propaganda.83a7d587.png";